(function () {
  var GIFT_PROPERTY_KEY = '_darek';
  var GIFT_PROPERTY_VALUE = '1';
  var DECLINED_STORAGE_PREFIX = 'tf-cart-gift-declined-';
  var LOCKED_VARIANT_STORAGE_PREFIX = 'tf-cart-gift-selected-';
  var SYNC_EVENT_NAMES = ['theme:cart:ready', 'theme:cart:updated'];
  var state = {
    syncToken: 0,
    syncInFlight: false,
    operationInFlight: false,
    pendingReason: null
  };

  function noop() {}

  function parseSectionSettings(node) {
    if (!node) {
      return null;
    }

    try {
      return JSON.parse(node.getAttribute('data-section-settings'));
    } catch (error) {
      return null;
    }
  }

  function getCartRoot() {
    var cartRoots = document.querySelectorAll('[data-section-type="cart-template"]');

    for (var i = 0; i < cartRoots.length; i += 1) {
      var settings = parseSectionSettings(cartRoots[i]);

      if (settings && Object.prototype.hasOwnProperty.call(settings, 'giftEnabled')) {
        return cartRoots[i];
      }
    }

    return null;
  }

  function normalizeGiftVariants(variants) {
    var normalizedVariants = [];
    var seenVariantIds = {};

    if (!Array.isArray(variants)) {
      return normalizedVariants;
    }

    for (var i = 0; i < variants.length; i += 1) {
      var variant = variants[i];
      var variantId = parseInt(variant && variant.id, 10) || 0;

      if (!variantId || seenVariantIds[variantId] || variant.available !== true) {
        continue;
      }

      seenVariantIds[variantId] = true;
      normalizedVariants.push({
        id: variantId,
        name: typeof variant.name === 'string' ? variant.name : '',
        available: true
      });
    }

    return normalizedVariants;
  }

  function getConfig() {
    var cartRoot = getCartRoot();
    var settings = parseSectionSettings(cartRoot);

    if (!settings) {
      return null;
    }

    return {
      currencyCode: settings.currencyCode,
      enabled: settings.giftEnabled === true,
      thresholdCents: parseInt(settings.giftThresholdCents, 10) || 0,
      collectionKey: settings.giftCollectionKey ? String(settings.giftCollectionKey) : '',
      availableVariants: normalizeGiftVariants(settings.giftVariants)
    };
  }

  function isGiftManagerEnabled(config) {
    return !!(
      config &&
      config.enabled &&
      config.currencyCode === 'CZK' &&
      config.thresholdCents > 0 &&
      config.collectionKey
    );
  }

  function getStorageValue(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function setStorageValue(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      noop();
    }
  }

  function removeStorageValue(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      noop();
    }
  }

  function getDeclineStorageKey(config) {
    return DECLINED_STORAGE_PREFIX + config.collectionKey;
  }

  function getGiftDeclined(config) {
    return getStorageValue(getDeclineStorageKey(config)) === '1';
  }

  function setGiftDeclined(config) {
    setStorageValue(getDeclineStorageKey(config), '1');
  }

  function getLockedVariantStorageKey(config) {
    return LOCKED_VARIANT_STORAGE_PREFIX + config.collectionKey;
  }

  function getLockedGiftVariantId(config) {
    return parseInt(getStorageValue(getLockedVariantStorageKey(config)), 10) || 0;
  }

  function setLockedGiftVariantId(config, variantId) {
    if (variantId > 0) {
      setStorageValue(getLockedVariantStorageKey(config), String(variantId));
      return;
    }

    removeStorageValue(getLockedVariantStorageKey(config));
  }

  function clearLockedGiftVariantId(config) {
    removeStorageValue(getLockedVariantStorageKey(config));
  }

  function isGiftItem(item) {
    return !!(
      item &&
      item.properties &&
      item.properties[GIFT_PROPERTY_KEY] === GIFT_PROPERTY_VALUE
    );
  }

  function getGiftLines(cart) {
    return (cart.items || []).filter(isGiftItem);
  }

  function getSubtotalWithoutGift(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      if (isGiftItem(item)) {
        return sum;
      }

      return sum + (item.final_line_price || 0);
    }, 0);
  }

  function getGiftLineVariantId(item) {
    return parseInt(item && (item.variant_id || item.id), 10) || 0;
  }

  function findAvailableVariantById(config, variantId) {
    for (var i = 0; i < config.availableVariants.length; i += 1) {
      if (config.availableVariants[i].id === variantId) {
        return config.availableVariants[i];
      }
    }

    return null;
  }

  function getRandomAvailableVariant(config, excludedVariantId) {
    var eligibleVariants = [];

    for (var i = 0; i < config.availableVariants.length; i += 1) {
      if (config.availableVariants[i].id !== excludedVariantId) {
        eligibleVariants.push(config.availableVariants[i]);
      }
    }

    if (!eligibleVariants.length) {
      return null;
    }

    return eligibleVariants[Math.floor(Math.random() * eligibleVariants.length)];
  }

  function resolveSelectedGiftVariant(config, preferredVariantId, excludedVariantId) {
    var preferredVariant = findAvailableVariantById(config, preferredVariantId);

    if (preferredVariant && preferredVariant.id !== excludedVariantId) {
      setLockedGiftVariantId(config, preferredVariant.id);
      return preferredVariant;
    }

    var lockedVariantId = getLockedGiftVariantId(config);
    var lockedVariant = findAvailableVariantById(config, lockedVariantId);

    if (lockedVariant && lockedVariant.id !== excludedVariantId) {
      return lockedVariant;
    }

    if (!config.availableVariants.length) {
      clearLockedGiftVariantId(config);
      return null;
    }

    var selectedVariant = getRandomAvailableVariant(config, excludedVariantId);

    if (!selectedVariant && excludedVariantId) {
      selectedVariant = getRandomAvailableVariant(config, 0);
    }

    if (!selectedVariant) {
      clearLockedGiftVariantId(config);
      return null;
    }

    setLockedGiftVariantId(config, selectedVariant.id);
    return selectedVariant;
  }

  function syncLockFromGiftLines(config, giftLines) {
    for (var i = 0; i < giftLines.length; i += 1) {
      var matchedVariant = findAvailableVariantById(config, getGiftLineVariantId(giftLines[i]));

      if (matchedVariant) {
        setLockedGiftVariantId(config, matchedVariant.id);
        return matchedVariant;
      }
    }

    return null;
  }

  function fetchCart() {
    return fetch(window.routes.cartUrl + '.js?timestamp=' + Date.now(), {
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      method: 'GET'
    }).then(function (response) {
      return response.json();
    });
  }

  function rerenderCart() {
    if (window.theme && typeof window.theme.rerenderCart === 'function') {
      return window.theme.rerenderCart();
    }

    return Promise.resolve();
  }

  function postCart(url, payload) {
    return fetch(url, {
      body: JSON.stringify(payload),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      method: 'POST'
    }).then(function (response) {
      if (!response.ok) {
        return false;
      }

      return response.json().then(function () {
        return true;
      }).catch(function () {
        return true;
      });
    }).catch(function () {
      return false;
    });
  }

  function finalizeOperation() {
    state.operationInFlight = false;

    if (state.pendingReason) {
      var nextReason = state.pendingReason;
      state.pendingReason = null;
      requestSync(nextReason);
    }
  }

  function applyGiftOperation(operation) {
    state.operationInFlight = true;

    return operation().then(function (didMutateCart) {
      if (!didMutateCart) {
        return false;
      }

      return rerenderCart().then(function () {
        return true;
      }).catch(function () {
        return true;
      });
    }).catch(function () {
      return false;
    }).then(function (result) {
      finalizeOperation();
      return result;
    }, function () {
      finalizeOperation();
      return false;
    });
  }

  function addGift(variantId) {
    return applyGiftOperation(function () {
      return postCart(window.routes.cartAddUrl + '.js', {
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
            _darek: '1'
          }
        }]
      });
    });
  }

  function addGiftWithFallback(config) {
    var selectedVariant = resolveSelectedGiftVariant(config, 0, 0);

    if (!selectedVariant) {
      return Promise.resolve(false);
    }

    return addGift(selectedVariant.id).then(function (didMutateCart) {
      if (didMutateCart) {
        return true;
      }

      var fallbackVariant = resolveSelectedGiftVariant(config, 0, selectedVariant.id);

      if (!fallbackVariant || fallbackVariant.id === selectedVariant.id) {
        return false;
      }

      return addGift(fallbackVariant.id);
    });
  }

  function updateGiftQuantities(updates) {
    return applyGiftOperation(function () {
      return postCart(window.routes.cartUrl + '/update.js', {
        updates: updates
      });
    });
  }

  function buildGiftUpdates(giftLines, retainedLineKey) {
    var updates = {};

    for (var i = 0; i < giftLines.length; i += 1) {
      updates[giftLines[i].key] = retainedLineKey && giftLines[i].key === retainedLineKey ? 1 : 0;
    }

    return updates;
  }

  function getRetainedGiftLine(giftLines, preferredVariantId) {
    if (preferredVariantId > 0) {
      for (var i = 0; i < giftLines.length; i += 1) {
        if (getGiftLineVariantId(giftLines[i]) === preferredVariantId) {
          return giftLines[i];
        }
      }
    }

    return giftLines[0] || null;
  }

  function reconcileCart(cart, config) {
    var giftLines = getGiftLines(cart);
    var subtotalWithoutGift = getSubtotalWithoutGift(cart);
    var thresholdReached = subtotalWithoutGift >= config.thresholdCents;
    var giftDeclined = getGiftDeclined(config);

    if (!thresholdReached && giftLines.length > 0) {
      return updateGiftQuantities(buildGiftUpdates(giftLines, null));
    }

    if (thresholdReached && giftLines.length === 0) {
      if (giftDeclined) {
        return Promise.resolve(false);
      }

      return addGiftWithFallback(config);
    }

    if (thresholdReached && giftLines.length > 0) {
      var syncedVariant = syncLockFromGiftLines(config, giftLines);

      if (!syncedVariant) {
        resolveSelectedGiftVariant(config, 0, 0);
      }

      var retainedLine = getRetainedGiftLine(giftLines, syncedVariant ? syncedVariant.id : 0);
      var needsNormalization = retainedLine && (giftLines.length > 1 || retainedLine.quantity !== 1);

      if (needsNormalization) {
        return updateGiftQuantities(buildGiftUpdates(giftLines, retainedLine.key));
      }
    }

    return Promise.resolve(false);
  }

  function runSync(syncToken) {
    var config = getConfig();

    if (!isGiftManagerEnabled(config)) {
      state.syncInFlight = false;
      state.pendingReason = null;
      return;
    }

    state.syncInFlight = true;

    fetchCart().then(function (cart) {
      if (syncToken !== state.syncToken) {
        return false;
      }

      return reconcileCart(cart, config);
    }).catch(noop).then(function () {
      state.syncInFlight = false;

      if (state.pendingReason) {
        var nextReason = state.pendingReason;
        state.pendingReason = null;
        requestSync(nextReason);
      }
    });
  }

  function requestSync(reason) {
    var config = getConfig();

    if (!isGiftManagerEnabled(config)) {
      return;
    }

    state.syncToken += 1;

    if (state.syncInFlight || state.operationInFlight) {
      state.pendingReason = reason;
      return;
    }

    runSync(state.syncToken);
  }

  function handleManualGiftRemoval(event) {
    var config = getConfig();

    if (!isGiftManagerEnabled(config)) {
      return;
    }

    var giftItem = event.target.closest('[data-cart-gift-item="true"]');

    if (!giftItem) {
      return;
    }

    var actionTarget = event.target.closest('[data-action="remove-item"], [data-action="update-item-quantity"]');

    if (actionTarget) {
      if (
        actionTarget.getAttribute('data-action') === 'remove-item' ||
        parseInt(actionTarget.getAttribute('data-quantity'), 10) === 0
      ) {
        setGiftDeclined(config);
      }

      return;
    }

    if (
      event.type === 'change' &&
      event.target.classList.contains('QuantitySelector__CurrentQuantity') &&
      parseInt(event.target.value, 10) === 0
    ) {
      setGiftDeclined(config);
    }
  }

  function init() {
    document.addEventListener('click', handleManualGiftRemoval);
    document.addEventListener('change', handleManualGiftRemoval);

    for (var i = 0; i < SYNC_EVENT_NAMES.length; i += 1) {
      document.addEventListener(SYNC_EVENT_NAMES[i], function (event) {
        requestSync(event.type);
      });
    }

    requestSync('init');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
